<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-document g-main-wrapper">
      <!-- filter -->
      <developerConfig-filter
        placeholder="请输入应用ID/应用名称"
        :media-data="mediaCallbackAddr"
        @on-set="editDeveloperConfig"
        @on-search="searchFilterData"
      />
      <!-- table -->
      <div class="c-table-list">
        <developerConfig-table
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          @on-refresh="getData"
          @on-edit="editDeveloperConfig"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page"
          size="small"
        />
      </div>

      <!-- 弹出框 -->
      <developerConfig-set
        ref="developerConfigSetRef"
        v-model="isModel"
        title="授权应用"
        :mediaCallbackAddr="mediaCallbackAddr"
        :edit="edit"
        :loading="loading"
        @on-save="saveDeveloperConfig"
      />
    </div>
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/developer_config_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, trim } from '@/common/js/utils'
import { getDeveloperConfig, updateDeveloperConfig, queryMediaCallbackAddr } from '@/api/developerConfig.model'
import developerConfigFilter from './components/developerConfig-filter.vue'
import developerConfigTable from './components/developerConfig-table.vue'
import developerConfigSet from './components/developerConfig-set.vue'
export default {
  name: 'developerConfig',
  mixins: [mixin],
  components: { developerConfigFilter, developerConfigTable, developerConfigSet },
  methods: {
    getData(filter) {
      if (filter) this.pageIndex = 1
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else if (this.params) params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      getDeveloperConfig(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    editDeveloperConfig(edit) {
      this.edit = !!edit
      if (edit) {
        const params = {
          id: edit.id,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        this.loading = true
        getDeveloperConfig(params)
          .then((data) => {
            this.loading = false
            if (data && isArray(data.list) && data.list.length === 1) {
              const { id, appId, mediaId, appName, callbackAddr, encryptionKey, authorizedAddr, manageId, adAccountBaseInfoList } =
                data.list[0]
              const adAccountList = adAccountBaseInfoList.map((ret) => {
                return {
                  id: ret.id,
                  name: ret.adAccount
                }
              })
              this.info = { state: 2, id, appId, mediaId, appName, callbackAddr, encryptionKey, authorizedAddr, manageId, adAccountList }
              this.isModel = true
              this.$nextTick(() => {
                this.$refs.developerConfigSetRef.setForm(this.info)
              })
            }
          })
          .catch((err) => {
            this.$Message.error({
              duration: 5,
              content: err
            })
          })
      } else {
        this.info = {
          state: 1,
          id: '',
          appId: '',
          mediaId: '',
          appName: '',
          callbackAddr: '',
          encryptionKey: '',
          authorizedAddr: '',
          manageId: '',
          adAccountList: []
        }
        this.isModel = true
      }
    },
    saveDeveloperConfig(params) {
      let { state, id, appId, mediaId, appName, callbackAddr, encryptionKey, authorizedAddr, manageId } = params
      callbackAddr = trim(callbackAddr)
      encryptionKey = trim(encryptionKey)
      authorizedAddr = trim(authorizedAddr)
      appId = trim(appId)
      appName = trim(appName)
      if (state >= 1 && state <= 2) {
        this.loading = true
        updateDeveloperConfig({ state, id, appId, mediaId, appName, callbackAddr, encryptionKey, authorizedAddr, manageId })
          .then((data) => {
            this.loading = false
            if (data) {
              if (state === 1) {
                this.$Message.success('添加成功！')
              }
              if (state === 2) {
                this.$Message.success('更新成功！')
              }
              this.getData()
              this.isModel = false
            }
          })
          .catch((err) => {
            this.$Message.error({
              duration: 5,
              content: err
            })
          })
      } else {
        this.$Message.error('操作失败！')
      }
    },
    setLocalPage(size) {
      setLocal('DOCUMENT_PAGESIZE', size)
    },
    proloadData() {
      Promise.all([queryMediaCallbackAddr()])
        .then((data) => {
          const [mediaCallbackAddr] = data
          if (isArray(mediaCallbackAddr)) {
            this.mediaCallbackAddr = mediaCallbackAddr.map((ret) => {
              return {
                id: ret.mediaId,
                name: ret.mediaName,
                callbackAddr: ret.callbackAddr
              }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  data() {
    return {
      isModel: false, // 弹窗开关
      edit: null,
      mediaCallbackAddr: [], // 媒体回调地址
      info: {}
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('DOCUMENT_PAGESIZE')) || 20
    this.tableCol = columns
    this.getData()
    this.proloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-document {
  width: 100%;
  height: 100%;
  padding: 8px 8px 0;
}

.c-table-list {
  height: calc(100% - 48px);
}

.c-table-page {
  padding: 0 8px;
  margin-bottom: 0;
  text-align: right;
}
</style>
